import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { DataExportResponse } from "./types";

export const useDataExport = (
  options?: UseMutationOptions<DataExportResponse, PortalAxiosError, void>
) => {
  const server = useServer();

  return useMutation<DataExportResponse, PortalAxiosError, void>(
    () => server.get("events/download"),
    options
  );
};

export default useDataExport;
